import { render, staticRenderFns } from "./number-of-quality-scores-chart.vue?vue&type=template&id=943e7f74"
import script from "./number-of-quality-scores-chart.vue?vue&type=script&lang=js"
export * from "./number-of-quality-scores-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports